export interface InsertedStyle {
  name: string;
  isGlobal: boolean;
}

export interface ServerStyleTag {
  dataEmotion: string;
  css: string;
}

/** <Global> and a component's keyframes both reach emotion's cache.insert with an empty selector. */
export function isGlobalInsert(selector: string, styles: string): boolean {
  const isKeyframes = styles.startsWith("@keyframes");
  return selector === "" && !isKeyframes;
}

/**
 * Global styles get one `<key>-global <name>` tag each: the client <Global> adopts a tag in that
 * shape and moves it ahead of the component styles. Folded in with the component styles, a copy
 * of every global rule stays at the end of the head and overrides components it ties with.
 */
export function buildServerStyleTags(
  cacheKey: string,
  styles: InsertedStyle[],
  inserted: Record<string, string | true | undefined>
): ServerStyleTag[] {
  const cssOf = (name: string) => (typeof inserted[name] === "string" ? inserted[name] : "");

  const globalTags = styles
    .filter((style) => style.isGlobal)
    .map((style) => ({ dataEmotion: `${cacheKey}-global ${style.name}`, css: cssOf(style.name) }));

  const componentNames = styles.filter((style) => !style.isGlobal).map((style) => style.name);
  if (componentNames.length === 0) {
    return globalTags;
  }

  const componentTag = {
    dataEmotion: `${cacheKey} ${componentNames.join(" ")}`,
    css: componentNames.map(cssOf).join(""),
  };
  return [...globalTags, componentTag];
}
